// Generated by xzor. Do not edit.
import { basePath, type Route, type RouteTable } from "@source-crafter/xzor-runtime";
import __p0 from "./pages/Home.xzor";
import __p1 from "./pages/HowItWorks.xzor";
import __p2 from "./pages/Kit.xzor";
import __p3 from "./pages/Learn.xzor";
import __p4 from "./pages/Recipes.xzor";
import __p5 from "./pages/Roadmap.xzor";
import __p6 from "./pages/Showcase.xzor";
import __p7 from "./pages/Start.xzor";

function __d(v: string): string | null {
  if (!v.includes("%")) return v;
  try {
    return decodeURIComponent(v);
  } catch {
    return null;
  }
}
const __decimal = /^-?\d+(?:\.\d+)?$/;
function __num(v: string): number {
  const d = __d(v);
  return d !== null && __decimal.test(d) ? Number(d) : NaN;
}

export type __P<C, K extends string> = K extends keyof C ? C[K] : string;

export const routes: RouteTable = [
  {
    tag: undefined,
    pattern: "/",
    family: "/",
    get component() {
      return __p0;
    },
    match: (s) => {
      if (s.length !== 0) return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/how-it-works",
    family: "/how-it-works",
    get component() {
      return __p1;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "how-it-works") return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/kit",
    family: "/kit",
    get component() {
      return __p2;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "kit") return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/learn/:step",
    family: "/learn/:step",
    get component() {
      return __p3;
    },
    match: (s) => {
      if (s.length !== 2) return null;
      if (s[0] !== "learn") return null;
      const _step = __num(s[1]!);
      if (Number.isNaN(_step)) return null;
      return { step: _step };
    },
  },
  {
    tag: undefined,
    pattern: "/recipes",
    family: "/recipes",
    get component() {
      return __p4;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "recipes") return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/roadmap",
    family: "/roadmap",
    get component() {
      return __p5;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "roadmap") return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/showcase",
    family: "/showcase",
    get component() {
      return __p6;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "showcase") return null;
      return {};
    },
  },
  {
    tag: undefined,
    pattern: "/start",
    family: "/start",
    get component() {
      return __p7;
    },
    match: (s) => {
      if (s.length !== 1) return null;
      if (s[0] !== "start") return null;
      return {};
    },
  },
];

function __href_Home(p?: Record<string, never>): string;
function __href_Home(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/";
  throw new Error("no route of Home matches these parameters");
}

function __href_HowItWorks(p?: Record<string, never>): string;
function __href_HowItWorks(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/how-it-works";
  throw new Error("no route of HowItWorks matches these parameters");
}

function __href_Kit(p?: Record<string, never>): string;
function __href_Kit(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/kit";
  throw new Error("no route of Kit matches these parameters");
}

function __href_Learn(p: { step: __P<__p3, "step"> }): string;
function __href_Learn(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 1 && p["step"] !== undefined) return basePath() + "/learn/" + encodeURIComponent(String(p["step"]));
  throw new Error("no route of Learn matches these parameters");
}

function __href_Recipes(p?: Record<string, never>): string;
function __href_Recipes(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/recipes";
  throw new Error("no route of Recipes matches these parameters");
}

function __href_Roadmap(p?: Record<string, never>): string;
function __href_Roadmap(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/roadmap";
  throw new Error("no route of Roadmap matches these parameters");
}

function __href_Showcase(p?: Record<string, never>): string;
function __href_Showcase(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/showcase";
  throw new Error("no route of Showcase matches these parameters");
}

function __href_Start(p?: Record<string, never>): string;
function __href_Start(p: Record<string, unknown> = {}): string {
  let n = 0;
  for (const k in p) if (p[k] !== undefined) n++;
  if (n === 0) return basePath() + "/start";
  throw new Error("no route of Start matches these parameters");
}

export const href = { Home: __href_Home, HowItWorks: __href_HowItWorks, Kit: __href_Kit, Learn: __href_Learn, Recipes: __href_Recipes, Roadmap: __href_Roadmap, Showcase: __href_Showcase, Start: __href_Start };

export type RouteTag = never;
export type RouteParams = {};
export type AppRoute<P = Record<string, unknown>> = Route<P, RouteParams>;
